import React from 'react';
import ReactDOM from 'react-dom';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import './index.css';
import './css/investorApp.css';
import App from './App';
import { preventBrowserBack } from './components/utils/preventBrowserBack';
import {
  unregisterServiceWorkers,
  installChunkErrorReload,
  startVersionCheck,
} from './utils/versionCheck';

// Always run the latest deployed build: drop any service worker left over from
// older versions (the app no longer registers one) and reload once if a lazy
// chunk of an old build can no longer be loaded after a deploy.
unregisterServiceWorkers();
installChunkErrorReload();
startVersionCheck();

preventBrowserBack();

const store = configureStore({});
{/*
ReactDOM.render(<Provider store={store}>
    <App />
    </Provider>
    , document.getElementById('root'));
*/} 
/* registerServiceWorker(); */
ReactDOM.render(<Provider store={store}>
    <App />
    </Provider>
    , document.getElementById('root'));
